import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useState, useCallback, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import Trigger from '@magento/venia-ui/lib/components/Trigger';
import classes from './zoomSliderModal.module.css';
import { PrevArrow, NextArrow } from './Icons';
import { CloseIcon, Image, PlusIcon, MinusIcon } from '../../../../components';
import { useWindowSize } from '@magento/peregrine';

var ZoomSliderModal = function ZoomSliderModal(_ref) {
  var closeModal = _ref.closeModal,
      images = _ref.images,
      activeSlider = _ref.activeSlider,
      setActiveSlider = _ref.setActiveSlider,
      productName = _ref.productName;

  var _useState = useState(1),
      _useState2 = _slicedToArray(_useState, 2),
      scaleImage = _useState2[0],
      setScaleImage = _useState2[1];

  var sliderRef = useRef();
  var innerRef = useRef();
  var outerRef = useRef();
  var windowSize = useWindowSize();
  var isMobile = windowSize.innerWidth <= 768;

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isMouseDown = _useState4[0],
      setIsMouseDown = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      startX = _useState6[0],
      setStartX = _useState6[1];

  var _useState7 = useState(0),
      _useState8 = _slicedToArray(_useState7, 2),
      scrollLeft = _useState8[0],
      setScrollLeft = _useState8[1];

  var CustomPrevArrow = useCallback(function (_ref2) {
    var className = _ref2.className,
        style = _ref2.style,
        _onClick = _ref2.onClick,
        currentSlide = _ref2.currentSlide,
        slideCount = _ref2.slideCount;
    return React.createElement(PrevArrow, {
      className: className,
      style: style,
      onClick: function onClick() {
        _onClick();

        handleImageRightScroll(currentSlide, slideCount);
      }
    });
  }, []);
  var CustomNextArrow = useCallback(function (_ref3) {
    var className = _ref3.className,
        style = _ref3.style,
        _onClick2 = _ref3.onClick,
        currentSlide = _ref3.currentSlide,
        slideCount = _ref3.slideCount;
    return React.createElement(NextArrow, {
      className: className,
      style: style,
      onClick: function onClick() {
        _onClick2();

        handleImageLeftScroll(currentSlide, slideCount);
      }
    });
  }, []);
  useEffect(function () {
    var _innerRef$current;

    var dotsChilds = innerRef === null || innerRef === void 0 ? void 0 : (_innerRef$current = innerRef.current) === null || _innerRef$current === void 0 ? void 0 : _innerRef$current.childNodes;

    if ((dotsChilds === null || dotsChilds === void 0 ? void 0 : dotsChilds.length) > 3) {
      var activeDot = dotsChilds[activeSlider].offsetLeft;

      if (activeDot) {
        outerRef.current.scroll({
          left: activeDot - 12 * dotsChilds.length,
          // 12px is the gap between dots(images)
          behavior: 'smooth'
        });
      }
    }
  }, []);
  useEffect(function () {
    var _sliderRef;

    (_sliderRef = sliderRef) === null || _sliderRef === void 0 ? void 0 : _sliderRef.slickGoTo(activeSlider);
  }, [sliderRef]);

  var handleImageRightScroll = function handleImageRightScroll(currentSlide, slideCount) {
    if (slideCount > 3) {
      var lastChildLeftOffset = innerRef.current.childNodes[slideCount - 1].offsetLeft;

      if (currentSlide === 0) {
        outerRef.current.scroll({
          left: lastChildLeftOffset + slideCount * 12,
          behavior: 'smooth'
        });
      } else {
        outerRef.current.scroll({
          left: outerRef.current.scrollLeft - 89,
          behavior: 'smooth'
        });
      }
    }
  };

  var handleImageLeftScroll = function handleImageLeftScroll(currentSlide, slideCount) {
    if (slideCount) {
      var firstChildLeftOffset = innerRef.current.childNodes[0].offsetLeft;

      if (currentSlide + 1 === slideCount) {
        outerRef.current.scroll({
          left: firstChildLeftOffset - slideCount * 12,
          behavior: 'smooth'
        });
      } else {
        outerRef.current.scroll({
          left: outerRef.current.scrollLeft + 89,
          behavior: 'smooth'
        });
      }
    }
  };

  var handleOnMouseDown = function handleOnMouseDown(e) {
    setStartX(e.pageX - outerRef.current.offsetLeft);
    setScrollLeft(outerRef.current.scrollLeft);
    setIsMouseDown(true);
  };

  var handleOnMouseLeave = function handleOnMouseLeave(e) {
    setIsMouseDown(false);
  };

  var handleOnMouseUp = function handleOnMouseUp(e) {
    setIsMouseDown(false);
  };

  var handleOnMouseMove = function handleOnMouseMove(e) {
    if (isMouseDown) {
      e.preventDefault();
      var x = e.pageX - outerRef.current.offsetLeft;
      var walk = (x - startX) * 2; // adjust the speed

      outerRef.current.scrollLeft = scrollLeft - walk;
    }
  };

  var handleOnWheel = function handleOnWheel(e) {
    outerRef.current.scrollLeft += e.deltaY;
  };

  var handleScrollTo = function handleScrollTo(idx) {
    return function () {
      sliderRef.slickGoTo(idx);
    };
  };

  var settings = {
    dots: true,
    speed: 500,
    infinite: true,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    useTransform: true,
    appendDots: function appendDots(dots) {
      return React.createElement("div", null, React.createElement("div", {
        className: "flex flex-col w-screen"
      }, React.createElement("div", {
        className: classes.scrollWrapper,
        ref: outerRef,
        onMouseDown: handleOnMouseDown,
        onMouseLeave: handleOnMouseLeave,
        onMouseUp: handleOnMouseUp,
        onMouseMove: handleOnMouseMove,
        onWheel: handleOnWheel
      }, React.createElement("ul", {
        className: classes.dotsWrapper,
        ref: innerRef
      }, dots.map(function (dot, idx) {
        var _images$idx, _images$idx2;

        return React.createElement("li", {
          "data-class": dot.props.className,
          className: "".concat(classes.dotWrapper, " ").concat(dot.props.className),
          key: idx,
          onClick: handleScrollTo(idx)
        }, React.createElement(Image, {
          resource: (images === null || images === void 0 ? void 0 : (_images$idx = images[idx]) === null || _images$idx === void 0 ? void 0 : _images$idx.file) || (images === null || images === void 0 ? void 0 : (_images$idx2 = images[idx]) === null || _images$idx2 === void 0 ? void 0 : _images$idx2.url),
          alt: productName,
          draggable: false
        }));
      }))), isMobile ? React.createElement("div", {
        className: "flex items-center justify-center"
      }, dots.map(function (dot, idx) {
        return React.createElement("button", {
          className: "".concat(dot.props.className),
          onClick: dot.props.children.props.onClick,
          "aria-label": "Dots"
        }, idx);
      })) : null));
    },
    beforeChange: function beforeChange(curr, next) {
      return setActiveSlider(next);
    },
    nextArrow: React.createElement(CustomNextArrow, null),
    prevArrow: React.createElement(CustomPrevArrow, null),
    onSwipe: function onSwipe(e) {
      return console.log(e);
    },
    onEdge: function onEdge(e) {
      return console.log(e);
    }
  };
  var CustomSlide = useCallback(function (props) {
    var style = props.style,
        item = props.item;
    return React.createElement(Image, {
      style: _objectSpread(_objectSpread({}, style), {}, {
        transform: "scale(".concat(scaleImage, ")")
      }),
      resource: (item === null || item === void 0 ? void 0 : item.file) || (item === null || item === void 0 ? void 0 : item.url),
      alt: productName,
      classes: {
        image: classes.mainImage
      }
    });
  }, [scaleImage]);
  var handleSclaseImage = useCallback(function (type) {
    if (type === 'increase') return setScaleImage(function (prevState) {
      return prevState + 0.1;
    });
    return setScaleImage(function (prevState) {
      return prevState - 0.1;
    });
  }, []);
  return React.createElement("div", {
    className: classes.root
  }, React.createElement("div", {
    className: classes.zoomButtons
  }, React.createElement(Trigger, {
    action: function action() {
      return handleSclaseImage('increase');
    },
    "aria-label": "Increase zoom image"
  }, React.createElement("span", {
    className: "sr-only"
  }, "Zoom in image"), React.createElement(PlusIcon, null)), React.createElement(Trigger, {
    action: function action() {
      return handleSclaseImage('decrease');
    },
    "aria-label": "Decrease zoom image"
  }, React.createElement("span", {
    className: "sr-only"
  }, "Zoom out image"), React.createElement(MinusIcon, null))), React.createElement("div", null), React.createElement(Slider, _extends({
    ref: function ref(slider) {
      return sliderRef = slider;
    }
  }, settings, {
    className: classes.sliderWrapper
  }), images === null || images === void 0 ? void 0 : images.map(function (item, idx) {
    return React.createElement(CustomSlide, {
      item: item,
      key: idx
    });
  })), React.createElement(Trigger, {
    classes: {
      root: classes.closeButton
    },
    action: closeModal,
    "aria-label": "Close zoom slider modal"
  }, React.createElement("span", {
    className: "sr-only"
  }, "Close modal"), React.createElement(CloseIcon, null)));
};

export default ZoomSliderModal;